export enum TabType {
    ACTIVE_SESSION,
    CHAT_HISTORY,
    USER_MANAGEMENT,
    METRIC_DASHBOARD,
    USER_REVIEW,
    QUESTION_DETAILS,
    MANAGE_DOCUMENTS
}